import { render, staticRenderFns } from "./stats_section_mobile.vue?vue&type=template&id=0ba867c0&scoped=true"
import script from "./stats_section_mobile.vue?vue&type=script&lang=js"
export * from "./stats_section_mobile.vue?vue&type=script&lang=js"
import style0 from "./stats_section_mobile.vue?vue&type=style&index=0&id=0ba867c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba867c0",
  null
  
)

export default component.exports